import { createApp } from 'vue';
import store from './store/store';
import LiveLocator from "./LiveLocator.vue";

declare global {
  interface Window {
    isPro: boolean;
    isProPlus: boolean;
    rcPublicKey: string;
    obfuscatedId: string;
  }
}

if (document.querySelector('#live_locator_web_viewer')) {
  const app = createApp(LiveLocator);
  app.use(store);
  app.mount('#live_locator_web_viewer');
}
